import Layout from '@/components/layout/Layout';
import ImpossibleContent from '@/components/tax-refund/result/Impossible/ImpossibleContent';

const ResultImpossiblePage = () => {
  return (
    <Layout>
      <ImpossibleContent />
    </Layout>
  );
};

export default ResultImpossiblePage;
